export const DEFAULT_CATALOG_FILTER_SETTING = {
  tech_brand_ids: true,
  tech_type_ids: true,
  d_wires: true,
  material_ids: true,
  spring_type_ids: true,
  country_ids: true,
  product_type_ids: true
}
